module.exports = __webpack_public_path__ + "img/apay.3da54d02.svg";